import { render, staticRenderFns } from "./VueDusionKeyboard.vue?vue&type=template&id=3f2ec1a2&scoped=true"
import script from "./VueDusionKeyboard.vue?vue&type=script&lang=js"
export * from "./VueDusionKeyboard.vue?vue&type=script&lang=js"
import style0 from "./VueDusionKeyboard.vue?vue&type=style&index=0&id=3f2ec1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ec1a2",
  null
  
)

export default component.exports